<template>
    <div class="more-message-container">
        <span :class="'one ' +(icon ||' one-info')"/>
        <label class="title-container">
            <span class="title-text">{{title||'更多须知'}}</span>
        </label>
        <span class="tip-content" v-if="$router.currentRoute.query.type === 'productManual'">
            <div class="tip-item">
                <img src="@/assets/svg/print.svg"/>
                <span class="desc">印制：先做样本，确认达到想要的效果后再批量印制；推荐2000米纸或157g铜版纸制作</span>
            </div>
            <div class="tip-item">
                <img src="@/assets/svg/ppt.svg"/>
                <span class="desc">软件：请使用Keynote/PPT打开手册，用WPS或者不同电脑打开，样式可能会有变形，打印前注意通篇检查</span>
            </div>
            <div class="tip-item">
                <img src="@/assets/svg/video.svg"/>
                <span class="desc"> 更多：产品手册制作和应用前，建议观看教程
                    <a target="_blank" href="https://school.alphalawyer.cn/#/service-center/detail?id=b9d41fd37fbf11eabd7db8599f49eeb4&type=liveCourse&currentRoute=entcourse">《“产品手册使用前必看：校友最佳实践”视频教程》</a></span>
            </div>
        </span>
        <span class="tip-content"  v-if="$router.currentRoute.query.type != 'productManual'">
            <div class="tip-item">
                <img src="@/assets/svg/print.svg"/>
                <span class="desc">课件制作方法，建议观看教程<a target="_blank"  href="https://school.alphalawyer.cn/#/service-center/detail?id=2578c73f0ff711eabd8a7cd30ae48328&type=liveCourse&currentRoute=entcourse">《如何制作PPT》</a></span>
            </div>
            <div class="tip-item">
                <img src="@/assets/svg/ppt.svg"/>
                <span class="desc">讲课技能训练，建议观看教程<a target="_blank"  href="https://school.alphalawyer.cn/#/service-center/detail?id=362249fb8af811eabd7db8599f49eeb4&type=liveCourse&currentRoute=entcourse">《如何线上直播课程》</a></span>
            </div>
            <div class="tip-item">
                <img src="@/assets/svg/video.svg"/>
                <span class="desc">举办市场活动，建议观看课程<a target="_blank"  href="https://school.alphalawyer.cn/#/record/detail/f6420486fed911e9bd8a7cd30ae48328/126">《律所如何打造市场活动》</a></span>
            </div>
        </span>
    </div>
</template>

<script>

    export default {
        name: "TemplateContainer",
        props: {tip: String, title: String, icon: String, contents: Array}
    }
</script>

<style scoped lang="scss">
    .more-message-container {
        color: #ED6C00;
        font-weight: 600;
        text-align: left;
        width: 727px;
        margin-top: 30px;

        .one {
            color: #ED6C00;
            font-size: 20px;
            position: relative;
            top: 6px;
            left: 4px;
            margin-right: 9px;
        }

        .title-container {
            display: inline-block;
            width: 680px;
            padding-bottom: 8px;

            .title-text {
                font-weight: 600;
                font-size: 14px;
                color: #ED6C00;
                border-bottom: 2px solid #ED6C00;
                padding-bottom: 8px;
            }

            border-bottom: 1px solid #C4C4C4;
        }

        .tip-content {
            margin-top: 20px;

            .tip-item {
                height: 180px;
                display: inline-block;
                float: left;
                text-align: center;
                margin-top: 56px;
                margin-left: 20px;
                margin-right: 10px;
            }

            img {
                height: 36px;
                display: inline-block;
                margin-right: 15px;
                float: left;
            }

            .one {
                font-size: 16px;
                line-height: 17px;
                color: #B1B1B1;
                margin-right: 12px;
                position: relative;
                top: 2px
            }

            .desc {
                font-size: 12px;
                line-height: 17px;
                color: #8C8C8C;
                width: 158px;
                display: inline-block;
                text-align: left;
                float: left;
                font-weight: normal;
                height: 77px;

                a {
                    color: #8C8C8C;
                    text-decoration: underline;

                    &:hover {
                        color: #ED6C00;
                    }
                }

            }

        }
    }
</style>